module.exports = __webpack_public_path__ + "img/Frame 427319758.1a1ac6b9.jpg";